import React from 'react';
import c from 'classnames';
import { W } from '../i18n';
import { ImmersivePopup } from '../';

import Policy from './components/Policy';
import Service from './components/Service';

import './PolicyAndServicePopup.global.styl';

interface Props {
  visible: boolean;
  onClose: () => void;
  currentTab: 'policy' | 'service';
  onChangeTab: (tab: 'policy' | 'service') => void;
}

function PolicyAndServicePopup({
  visible,
  onClose,
  currentTab,
  onChangeTab,
}: Props) {
  return (
    <ImmersivePopup visible={visible} onClose={onClose}>
      <div className="PolicyAndServicePopup">
        <div className="PolicyAndServicePopup__tabRow">
          <span
            className={c('PolicyAndServicePopup__tabRow__tabButton', {
              active: currentTab === 'service',
            })}
            onClick={() => onChangeTab('service')}
          >
            {W('shared.footer.button.service')}
          </span>
          <span
            className={c('PolicyAndServicePopup__tabRow__tabButton', {
              active: currentTab === 'policy',
            })}
            onClick={() => onChangeTab('policy')}
          >
            {W('shared.footer.button.policy')}
          </span>
        </div>

        <Policy visible={currentTab === 'policy'} />
        <Service visible={currentTab === 'service'} />
      </div>
    </ImmersivePopup>
  );
}

export default PolicyAndServicePopup;
